/** How much of what came before shows above the row a stream opens at. */
const ABOVE = 40

/**
 * Open `scroller` at `row`, with 40px of what came before above it, unless
 * the bottom is closer or there is no row, which opens it at the bottom, as
 * Slack does. Says whether it opened at the bottom, the only place a reader
 * is kept at as new messages arrive. A `reversed` scroller (column-reverse)
 * starts at the bottom with `scrollTop` 0 and scrolls up into negatives.
 */
export function openAt(scroller: HTMLElement, row: Element | null, reversed = false): boolean {
  const bottom = reversed ? 0 : scroller.scrollHeight - scroller.clientHeight
  const top = row
    ? scroller.scrollTop + row.getBoundingClientRect().top - scroller.getBoundingClientRect().top - ABOVE
    : bottom
  if (top >= bottom) {
    scroller.scrollTop = reversed ? 0 : scroller.scrollHeight
    return true
  }
  scroller.scrollTop = top
  return false
}
